(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

document.addEventListener('DOMContentLoaded', function () {
  const panel = document.querySelector('#CustomSearchPanel');
  if (panel && panel.parentElement !== document.body) {
    document.body.appendChild(panel);
  }
  const closeBtn = panel?.querySelector('.custom-search-panel__close');
  const overlay = panel?.querySelector('.custom-search-panel__overlay');
  const form = panel?.querySelector('.custom-search-panel__form');
  const filtersContainer = panel?.querySelector('#CustomSearchFilters');
  const resetButton = panel?.querySelector('.custom-search-panel__reset');
  const keywordInput = panel?.querySelector('.custom-search-panel__input');

  if (!panel || !form || !filtersContainer) return;

  let filtersLoaded = false;
  let filtersLoading = false;

  /**
   * 検索パネルを開く
   */
  const openPanel = async () => {
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    document.body.classList.add('custom-search-is-open');

    if (!filtersLoaded && !filtersLoading) {
      await loadSearchFilters();
    }

    window.setTimeout(() => {
      keywordInput?.focus();
    }, 300);
  };

  /**
   * 検索パネルを閉じる
   */
  const closePanel = () => {
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('custom-search-is-open');
  };

  /**
   * 検索ページからフィルターHTMLを取得
   */
  const loadSearchFilters = async () => {
    filtersLoading = true;

    try {
      const searchUrl = new URL(window.Shopify.routes.root + 'search', window.location.origin);

      searchUrl.searchParams.set('q', '*');
      searchUrl.searchParams.set('type', 'product');
      searchUrl.searchParams.set('options[prefix]', 'last');

      const response = await fetch(searchUrl.toString(), {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error(`Search filter request failed: ${response.status}`);
      }

      const html = await response.text();
      const parser = new DOMParser();
      const documentData = parser.parseFromString(html, 'text/html');

      const sourceWrapper = documentData.querySelector('#FacetsWrapperMobile');

      if (!sourceWrapper) {
        throw new Error('Search filter markup was not found.');
      }

      const sourceDetails = Array.from(
        sourceWrapper.querySelectorAll(':scope > .mobile-facets__details')
      );

      filtersContainer.innerHTML = '';

      sourceDetails.forEach((sourceDetail, index) => {
        const label =
          sourceDetail.querySelector('.mobile-facets__summary span:first-child')
            ?.textContent
            ?.trim() || '';

        /**
         * カンプにはブランド・並び替えがないので除外
         */
        if (
          !label ||
          label === 'ブランド' ||
          label.includes('並び替え')
        ) {
          return;
        }

        const sourceSubmenu = sourceDetail.querySelector('.mobile-facets__submenu');

        if (!sourceSubmenu) return;

        const detail = document.createElement('details');
        detail.className = 'custom-search-filter';
        detail.dataset.filterLabel = label;

        const summary = document.createElement('summary');
        summary.className = 'custom-search-filter__summary';

        const title = document.createElement('span');
        title.className = 'custom-search-filter__title';
        title.textContent = label;

        const icon = document.createElement('span');
        icon.className = 'custom-search-filter__icon';
        icon.setAttribute('aria-hidden', 'true');

        summary.appendChild(title);
        summary.appendChild(icon);

        const content = document.createElement('div');
        content.className = 'custom-search-filter__content';

        const clonedContent = document.createElement('div');
        clonedContent.className = 'custom-search-filter__fields';
        clonedContent.innerHTML = sourceSubmenu.innerHTML;

        /**
         * Dawn標準の戻るボタン・内部フッターは不要
         */
        clonedContent
          .querySelectorAll(
            '.mobile-facets__close-button, .mobile-facets__footer'
          )
          .forEach((element) => element.remove());

        /**
         * IDとlabelのfor属性を検索パネル専用へ変更
         */
        const idMap = new Map();

        clonedContent
          .querySelectorAll('[id]')
          .forEach((element, elementIndex) => {
            const oldId = element.id;
            const newId = `CustomSearchFilter-${index}-${elementIndex}`;

            idMap.set(oldId, newId);
            element.id = newId;
          });

        clonedContent
          .querySelectorAll('label[for]')
          .forEach((labelElement) => {
            const oldFor = labelElement.getAttribute('for');

            if (idMap.has(oldFor)) {
              labelElement.setAttribute('for', idMap.get(oldFor));
            }
          });

        /**
         * 元のモバイル絞り込みフォームとの紐付けを解除
         */
        clonedContent
          .querySelectorAll('input, select')
          .forEach((input) => {
            input.removeAttribute('form');
          });

        content.appendChild(clonedContent);
        detail.appendChild(summary);
        detail.appendChild(content);
        filtersContainer.appendChild(detail);
      });

      filtersLoaded = true;

      if (!filtersContainer.children.length) {
        filtersContainer.innerHTML = `
          <p class="custom-search-panel__error">
            絞り込み条件を取得できませんでした。
          </p>
        `;
      }
    } catch (error) {
      console.error(error);

      filtersContainer.innerHTML = `
        <p class="custom-search-panel__error">
          絞り込み条件を取得できませんでした。
        </p>
      `;
    } finally {
      filtersLoading = false;
    }
  };

  /**
   * 検索アイコン
   */
  document.addEventListener('click', function (event) {
    const openButton = event.target.closest('.custom-search-open');

    if (!openButton) return;

    event.preventDefault();
    openPanel();
  });

  /**
   * 閉じる
   */
  closeBtn?.addEventListener('click', closePanel);
  overlay?.addEventListener('click', closePanel);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && panel.classList.contains('is-open')) {
      closePanel();
    }
  });

/**
 * リセット
 */
resetButton?.addEventListener('click', function (event) {
  event.preventDefault();

  /**
   * チェックボックス・ラジオを解除
   */
  form
    .querySelectorAll('input[type="checkbox"], input[type="radio"]')
    .forEach((input) => {
      input.checked = false;
    });

  /**
   * 価格入力を空にする
   *
   * price-facetの入力はtype="number"とは限らないため、
   * name属性とprice-range内のinputを対象にする
   */
  form
    .querySelectorAll(
      'price-range input,' +
      'input[name="filter.v.price.gte"],' +
      'input[name="filter.v.price.lte"]'
    )
    .forEach((input) => {
      input.value = '';
      input.removeAttribute('value');
    });

  /**
   * キーワードを空にする
   */
  if (keywordInput) {
    keywordInput.value = '';
  }

  /**
   * アコーディオンは現在の開閉状態を維持する
   * ここではopen属性を変更しない
   */
});

  /**
   * 空のキーワードでも商品検索として送信
   */
  form.addEventListener('submit', function () {
    if (keywordInput && keywordInput.value.trim() === '') {
      keywordInput.value = '*';
    }

    let typeInput = form.querySelector('input[name="type"]');

    if (!typeInput) {
      typeInput = document.createElement('input');
      typeInput.type = 'hidden';
      typeInput.name = 'type';
      form.appendChild(typeInput);
    }

    typeInput.value = 'product';

    let prefixInput = form.querySelector('input[name="options[prefix]"]');

    if (!prefixInput) {
      prefixInput = document.createElement('input');
      prefixInput.type = 'hidden';
      prefixInput.name = 'options[prefix]';
      form.appendChild(prefixInput);
    }

    prefixInput.value = 'last';
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const megaItems = document.querySelectorAll('.brand-site-header__nav-item--mega');

  megaItems.forEach(function (item) {
    const button = item.querySelector('.brand-site-header__nav-button');
    const mega = item.querySelector('.brand-site-header__mega');
    let closeTimer;

    if (!button || !mega) return;

    const openMega = function () {
      clearTimeout(closeTimer);
      item.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
    };

    const closeMega = function () {
      closeTimer = setTimeout(function () {
        item.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
      }, 180);
    };

    item.addEventListener('mouseenter', openMega);
    item.addEventListener('mouseleave', closeMega);

    mega.addEventListener('mouseenter', openMega);
    mega.addEventListener('mouseleave', closeMega);

    button.addEventListener('click', function (e) {
      e.preventDefault();
      item.classList.toggle('is-open');
      button.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
    });

    document.addEventListener('click', function (e) {
      if (!item.contains(e.target)) {
        item.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-coord-slider"]) return;
  try {
    
document.querySelectorAll('[data-mw-coord-slider]').forEach(function (slider) {
  var images = slider.querySelectorAll('.coord-slider__image');
  var dots = slider.querySelectorAll('.coord-slider__dot');
  var prevBtn = slider.querySelector('.coord-slider__arrow--prev');
  var nextBtn = slider.querySelector('.coord-slider__arrow--next');
  var current = 0;

  if (images.length === 0) return;

  function show(index) {
    current = (index + images.length) % images.length;
    images.forEach(function (img, i) {
      img.classList.toggle('is-active', i === current);
    });
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === current);
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      show(current - 1);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      show(current + 1);
    });
  }

  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () {
      show(i);
    });
  });

  show(0);
});

  } catch(e) { console.error(e); }
})();
})();
